import { takeEvery } from 'redux-saga/effects';
import { ClientLicenseType } from '~/_shared/types/client/license';
import { sendGAEvent } from '~/_shared/utils/3rdPartyIntegrations/ga/ga.helpers';
import { GAEventName } from '~/_shared/utils/3rdPartyIntegrations/ga/ga.types';
import { type PickAction } from '~/_shared/utils/types/action.type';
import { MemberRoles } from '~/clientTeamManagement/teamManagementModal/memberRole.type';
import { type UserDataAction } from './userData.action';
import { USER_GET_DATA_SUCCESS } from './userData.actionTypes';

function onUserGetDataSuccess(action: PickAction<UserDataAction, typeof USER_GET_DATA_SUCCESS>) {
  const { usage: { firstSignIn }, clientRole, currentClient } = action.payload.data;
  const isOwner = clientRole === MemberRoles.COMPANY_OWNER;
  const isTrialLicense = currentClient?.license.type === ClientLicenseType.TRIAL;

  if (firstSignIn && isTrialLicense && isOwner) {
    sendGAEvent(GAEventName.Trial);
  }
}

export function* userDataGAEventsSagas() {
  yield takeEvery(USER_GET_DATA_SUCCESS, onUserGetDataSuccess);
}
